import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CompanyNewInterface } from "../../../../models/GeneralModule/CompanyNews";
import companyNewService from "../../../../services/general/companyNewService";
import { CACHE_KEY_COMPANYNEWS } from "../../../../utils/constants";

interface AddCompanyNewsContext {
  previousCompanyNews: CompanyNewInterface[];
}

const useAddCompanyNew = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CompanyNewInterface,
    Error,
    CompanyNewInterface,
    AddCompanyNewsContext
  >({
    mutationFn: companyNewService.Save,

    onMutate: () => {
      const previousCompanyNews =
        queryClient.getQueryData<CompanyNewInterface[]>([
          CACHE_KEY_COMPANYNEWS,
        ]) || [];

      return { previousCompanyNews };
    },

    onSuccess: (savedCompanyNew) => {
      queryClient.setQueryData<CompanyNewInterface[]>(
        [CACHE_KEY_COMPANYNEWS],
        (companyNews) =>
          companyNews ? [savedCompanyNew, ...companyNews] : [savedCompanyNew]
      );
    },

    onError: (error, newCompanyNew, context) => {
      if (!context) return;

      queryClient.setQueryData<CompanyNewInterface[]>(
        [CACHE_KEY_COMPANYNEWS],
        context.previousCompanyNews
      );
    },
  });
};

export default useAddCompanyNew;
